"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimulatedPersonDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const Intention_dto_1 = require("./Intention.dto");
class SimulatedPersonDto {}
exports.SimulatedPersonDto = SimulatedPersonDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], SimulatedPersonDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], SimulatedPersonDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], SimulatedPersonDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Public image URL or S3 object path.'
}), __metadata("design:type", Object)], SimulatedPersonDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.Gender
}), __metadata("design:type", String)], SimulatedPersonDto.prototype, "gender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.SubGender,
  required: false,
  nullable: true
}), __metadata("design:type", Object)], SimulatedPersonDto.prototype, "subGender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [String],
  enum: enums_1.Gender
}), __metadata("design:type", Array)], SimulatedPersonDto.prototype, "preferredGenders", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether preferred genders should be shown on the viewer UI.'
}), __metadata("design:type", Boolean)], SimulatedPersonDto.prototype, "showGenderPreferences", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Date of birth in MM-DD-YYYY (UTC).'
}), __metadata("design:type", String)], SimulatedPersonDto.prototype, "dateOfBirth", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], SimulatedPersonDto.prototype, "age", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], SimulatedPersonDto.prototype, "vibeEmoji", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  type: Intention_dto_1.IntentionDto
}), __metadata("design:type", Object)], SimulatedPersonDto.prototype, "intention", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Shown as photo-verified in venue / profile UIs.'
}), __metadata("design:type", Boolean)], SimulatedPersonDto.prototype, "isPhotoVerified", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Inactive personas are hidden from spawn / overlay flows.'
}), __metadata("design:type", Boolean)], SimulatedPersonDto.prototype, "isActive", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Admin-only notes.'
}), __metadata("design:type", Object)], SimulatedPersonDto.prototype, "notes", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], SimulatedPersonDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], SimulatedPersonDto.prototype, "updatedAt", void 0);
//# sourceMappingURL=SimulatedPerson.dto.js.map